import { useState } from "react";
import Page404 from "@pages/NotFoundPage"
import MapView from "@components/Map";
import { useTranslation } from "react-i18next";
import PageHeader from "@components/PageHeader";

const WhereWeArepage = () => {
    const { t } = useTranslation();
    const [isPageNotFound, setIsPageNotFound] = useState(false);

    return (
        <div className="mx-3 mb-5 mb-lg-0">
            {isPageNotFound ? (<Page404 />) : (
                <div>
                    <div className="sticky-top sticky-header border-bottom border-light">
                    <PageHeader pageTitle={t("text.whereWeAre")} flagSearch={false} flag={false}/>
                    </div>
                    <MapView/>
                </div>)}
        </div>
    )
}
export default WhereWeArepage